import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { SliderImages } from '../../components/swipper/SliderImages';
import withScrollHandler from '../../hoc/withScrollHandler';
import { HeadLine } from '../../layouts/headers/HeadLine';
import SpaCardComponent from './SpaCardComponent';
import './Style.css';

const SpaMainPage = ({ scrollpos, handleScroll, bgimage }) => {

    const checkIcon = <FontAwesomeIcon icon={faCheck} color='#67BAAF' />

    const images = [
        '/assets/img/spa_1.png',
        '/assets/img/spa_2.png',
        '/assets/img/gym_1.png',
        '/assets/img/gym_2.png'
    ];

    return (
        <div>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Spa' backurl='/' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
                    <img src="/assets/img/icons/spa-icon.svg" alt="Icono spa" />
                </div>
            </div>


            <div className="absolute z-1 w-full border shadow detail-experience-container pb-4 bg_page_top"
                onScroll={handleScroll} style={{ height: `calc(100% - ${scrollpos}px)` }}>
                <div>Relajate y déjate consentir en nuestro Spa</div>

                <div className='flex justify-start items-center mt-4 mb-4 gap-10' style={{ color: '#4B5563' }}>
                    <div className='inline-flex items-center'>
                        <img src="/assets/img/icons/clock-icon.svg" alt="clock icon" className='mr-1' width={'26px'} height={'26px'} />
                        <strong>Abre:</strong>&nbsp; 6:00 a.m.
                    </div>
                    <div>
                        <strong>Abre:</strong>&nbsp; 6:00 a.m.
                    </div>
                </div>


                <SliderImages onclickitem={() => { }} items={images} />

                <div className='flex flex-col gap-4 mt-4'>
                    <div>{checkIcon}&nbsp; Clases de gimnasia disponibles</div>
                    <div>
                        {checkIcon}&nbsp; Envoltura corporal
                    </div>

                    <div>
                        {checkIcon}&nbsp; Masaje en pareja
                    </div>

                    <div>
                        {checkIcon}&nbsp; Masajes
                    </div>
                    <div>
                        {checkIcon}&nbsp; Tratamientos faciales
                    </div>
                </div>


                <div className='flex justify-start gap-2 items-center mt-8'>
                    <span>
                        <img src="/assets/img/icons/spa2-icon.svg" alt="Icono masaje 2" width={'32px'} height={'32px'} />
                    </span> <span>¿Qué tipo de masaje deseas?</span>
                </div>

                <div className='flex justify-between items-center mt-8 mb-8'>
                    <div>
                        Fecha de servicio:
                    </div>
                    <div className="inline-block relative" style={{ width: '166px' }}>
                        <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                            style={{ height: '50px' }}>
                            <option>1 - Dic - 2021</option>
                            <option>2 - Dic - 2021</option>
                            <option>3 - Dic - 2021</option>
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 he-50">
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>

                <SpaCardComponent />

               
            </div>
        </div>


    );
};


export default withScrollHandler(SpaMainPage, { scrollinit: 260, namebg: 'spa_bg.png' });